export const DEFAULT_COLOR = '#000000';
export const DEFAULT_FONTSIZE = 14;
export const dateFormat = 'DD.MM.YYYY HH:mm';
export const DEFAULT_ROTATE = 45;
export const DEFAULT_OPACITY = 0.2;
export const DEFAULT_REPEAT = 300;
